import {useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import useHttpHandler from "../../../hooks/httpHandler";
import {useEffect} from "react";

const usePaymentDetails = () => {
    const {post} = useHttpHandler()
    const [searchParams, setSearchParams] = useSearchParams();
    const uMversion = searchParams.get('UMversion')
    const uMstatus = searchParams.get('UMstatus')
    const uMauthCode = searchParams.get('UMauthCode')
    const uMrefNum = searchParams.get('UMrefNum')
    const uMavsResult = searchParams.get('UMavsResult')
    const uMavsResultCode = searchParams.get('UMavsResultCode')
    const uMcvv2Result = searchParams.get('UMcvv2Result')
    const uMcvv2ResultCode = searchParams.get('UMcvv2ResultCode')
    const uMresult = searchParams.get('UMresult')
    const uMvpasResultCode = searchParams.get('UMvpasResultCode')
    const uMerror = searchParams.get('UMerror')
    const uMerrorcode = searchParams.get('UMerrorcode')
    const uMcustnum = searchParams.get('UMcustnum')
    const uMbatch = searchParams.get('UMbatch')
    const uMbatchRefNum = searchParams.get('UMbatchRefNum')
    const uMisDuplicate = searchParams.get('UMisDuplicate')
    const uMconvertedAmount = searchParams.get('UMconvertedAmount')
    const uMconvertedAmountCurrency = searchParams.get('UMconvertedAmountCurrency')
    const uMconversionRate = searchParams.get('UMconversionRate')
    const uMcustReceiptResult = searchParams.get('UMcustReceiptResult')
    const uMprocRefNum = searchParams.get('UMprocRefNum')
    const uMcardLevelResult = searchParams.get('UMcardLevelResult')
    const uMauthAmount = searchParams.get('UMauthAmount')
    const uMcardRef = searchParams.get('UMcardRef')
    const uMcardType = searchParams.get('UMcardType')
    const uMmaskedCardNum = searchParams.get('UMmaskedCardNum')
    const uMsubmit = searchParams.get('UMsubmit')
    const uMredir = searchParams.get('UMredir')
    const uMkey = searchParams.get('UMkey')
    const mpgUserId = searchParams.get('mpgUserId')
    const uMNewKey = searchParams.get('UMNewKey')
    const uMamount = searchParams.get('UMamount')
    const uMinvoice = searchParams.get('UMinvoice')
    const uMorderid = searchParams.get('UMorderid')
    const uMredirApproved = searchParams.get('UMredirApproved')
    const uMredirDeclined = searchParams.get('UMredirDeclined')
    const uMhash = searchParams.get('UMhash')
    const uMcommand = searchParams.get('UMcommand')
    const uMechofields = searchParams.get('UMechofields')
    const uMformString = searchParams.get('UMformString')
    const uMcard = searchParams.get('UMcard')
    const uMname = searchParams.get('UMname')
    const uMexpir = searchParams.get('UMexpir')
    const uMzip = searchParams.get('UMzip')
    const cardnickname = searchParams.get('cardnickname')

    const isUmStatusApproved = uMstatus === 'Approved'
    const isUmStatusError = uMstatus === 'Error'
    const isUmStatusDeclined = uMstatus === 'Declined'
    const userId = sessionStorage.getItem('userId')
    const iFrameUrl=process.env.REACT_APP_CREDITCARD_IFRAME_URL

    console.log("userid="+userId+"--iframeurl="+iFrameUrl);
    const updateCardDetails = () => {
        const body = {
            UMcardRef: uMcardRef,
            UMname: uMname,
            cardnickname: cardnickname,
            UMcardType: uMcardType,
            UMcard: uMcard,
            UMzip: uMzip,
            mpgUserId: mpgUserId
        }
        post('card/details', body).then((res) => {
            toast.success('Card details updated')
        }).catch(err => {

        })
    }

    const goBackToCardPage = ()=>{
        //window.localtion.href=`${iFrameUrl}${userId}`
        window.location.href = ` https://secure.usaepay.com/interface/epayform/2UUKBnZY8MaH5ThxA9UHa5LPe5MzNCCH?mpgUserId=${userId}`
        //window.location.href = `https://secure.usaepay.com/interface/epayform/jiWugixAbL26103WocN23KzaSqDB4dY8?mpgUserId=${mpgUserId}`
    }

    useEffect(() => {
        if (isUmStatusApproved) {
            updateCardDetails()
        } else {
            toast.error(uMerror)
            setTimeout(()=>{
                goBackToCardPage()
            }, 2000)

        }
    }, [])

    return (
        {
            isUmStatusApproved,
            isUmStatusError,
            mpgUserId
        }
    )
}

export default usePaymentDetails